import { render } from "./VascularDataMaterial.vue?vue&type=template&id=7c6a77ba"
import script from "./VascularDataMaterial.vue?vue&type=script&lang=js"
export * from "./VascularDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__